import { render } from "./TournamentCard.vue?vue&type=template&id=6664044e"
import script from "./TournamentCard.vue?vue&type=script&lang=js"
export * from "./TournamentCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__